import { render, staticRenderFns } from "./OperLogList.vue?vue&type=template&id=b2415994&"
import script from "./OperLogList.vue?vue&type=script&lang=js&"
export * from "./OperLogList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports